export default "__VITE_ASSET__88eVxXS9__"